export default "__VITE_ASSET__oescEnV5__"